const settings = {
  local: {
    featureFlags: {
      showFirmRegistration: false,
      showConfigOverrides: true,
      disableSelfSignup: true,
      profiles: true,
      scheduleEnvironment: true,
      cats: true,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomolocal.cirencester-friendly.co.uk',
      siteId: 2
    },
    links: {
      firmRegistration: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      loginUserType: 'https://localhost:3000/login',
      //loginUserType: 'https://staging.cirencester-friendly.com/login/'
      menuHome: 'https://staging.cirencester-friendly.com',
      menuAboutUs: 'https://staging.cirencester-friendly.com/about-us/',
      governance: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/',
      accounts: 'https://staging.cirencester-friendly.com/documents/annual-reports-and-accounts/latest/',
      legal: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/legal/',
      cookies: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://staging.cirencester-friendly.com/documents/Privacy_Notice.pdf',
      accessibility: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://staging.cirencester-friendly.com/adviser/',
      menuMember: 'https://staging.cirencester-friendly.com/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_87ztWeh5V",
      APP_CLIENT_ID: "26vlqv7d6u35jqtmppf3fffi0a",
      allowDelete: true,
      allowAdminDelete: true,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@sj[p]{1,2}\\.co\\.uk$",
        name: "St. James' Place",
        provider: "SJP",
      },
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      },
      {
        regex: "^.+@your-domain\\.co\\.uk$",
        name: "Your organisation",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LcoEvIcAAAAACrarxZfNRb1yYkvMAKWgWEqrZTD"
    },
    oauth: {
      domain: 'cfs-signin-uat.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://localhost:3000/login',
      redirectSignOut: 'https://localhost:3000/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        // sys
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal/',

        // UAT
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal//',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/Quote/SecureApply',

        // PP
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        
        // quotesIN2
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',

        // SSG-IN2
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        // IPL 1501/5
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_AdviserPortal/security/logon',
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_CustomerPortal/security/logon',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/Apply/',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/SecureApply',
      ],
      // Groups for federated users.
      federatedGroups: [
        "eu-west-2_87ztWeh5V_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'http://localhost:8888/api',
    },
    ssgAdviserItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1500_copSSG_AdviserPortal"
      },
      {
        title: "SSG iPipeline 1530",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1530_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal"
      },
    ],
    ssgMemberItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tst01-web-a.tcp.local/tst_env_1500_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal"
      },
    ],
    dataItems: [
      {
        title: "PP Data Pipeline",
        link: "https://dagsterpp.cirencester-friendly.co.uk/runs",
      },
    ],
  },
  // DEV #######################################################################
  dev: {
    featureFlags: {
      showFirmRegistration: false,
      showConfigOverrides: true,
      disableSelfSignup: true,
      profiles: true,
      scheduleEnvironment: true,
      cats: false,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomouat.cirencester-friendly.co.uk',
      siteId: 2
    },
    links: {
      firmRegistration: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      loginUserType: '/login',
      menuHome: 'https://staging.cirencester-friendly.com',
      menuAboutUs: 'https://staging.cirencester-friendly.com/about-us/',
      governance: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/',
      accounts: 'https://staging.cirencester-friendly.com/documents/annual-reports-and-accounts/latest/',
      legal: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/legal/',
      cookies: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://staging.cirencester-friendly.com/documents/Privacy_Notice.pdf',
      accessibility: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://staging.cirencester-friendly.com/adviser/',
      menuMember: 'https://staging.cirencester-friendly.com/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_87ztWeh5V",
      APP_CLIENT_ID: "26vlqv7d6u35jqtmppf3fffi0a",
      allowDelete: true,
      allowAdminDelete: true,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@sj[p]{1,2}\\.co\\.uk$",
        name: "St. James' Place",
        provider: "SJP",
      },
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    },
    oauth: {
      domain: 'cfs-signin-uat.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://gatewaydev.cirencester-friendly.com/login',
      redirectSignOut: 'https://gatewaydev.cirencester-friendly.com/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        // sys
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal/',

        // UAT
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal//',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/Quote/SecureApply',

        // PP
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        
        // quotesIN2
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',

        // SSG-IN2
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        // IPL 1501/5
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_AdviserPortal/security/logon',
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_CustomerPortal/security/logon',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/Apply/',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/SecureApply',
      ],
      // Groups for federated users.
      federatedGroups: [
        "eu-west-2_87ztWeh5V_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'https://cesbuat.cirencester-friendly.co.uk/api'
    },
    ssgAdviserItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1500_copSSG_AdviserPortal"
      },
      {
        title: "SSG iPipeline 1530",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1530_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal"
      },
    ],
    ssgMemberItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tst01-web-a.tcp.local/tst_env_1500_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal"
      },
    ],
    dataItems: [],
  },
  // UAT #######################################################################
  uat: {
    featureFlags: {
      showFirmRegistration: true,
      showConfigOverrides: true,
      disableSelfSignup: true,
      profiles: true,
      scheduleEnvironment: true,
      cats: false,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomouat.cirencester-friendly.co.uk',
      siteId: 2
    },
    links: {
      firmRegistration: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      //loginUserType: '/login',
      loginUserType: 'https://staging.cirencester-friendly.com/login/',
      menuHome: 'https://staging.cirencester-friendly.com',
      menuAboutUs: 'https://staging.cirencester-friendly.com/about-us/',
      governance: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/',
      accounts: 'https://staging.cirencester-friendly.com/documents/annual-reports-and-accounts/latest/',
      legal: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/legal/',
      cookies: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://staging.cirencester-friendly.com/documents/Privacy_Notice.pdf',
      accessibility: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://staging.cirencester-friendly.com/adviser/',
      menuMember: 'https://staging.cirencester-friendly.com/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
      
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_87ztWeh5V",
      APP_CLIENT_ID: "26vlqv7d6u35jqtmppf3fffi0a",
      allowDelete: true,
      allowAdminDelete: true,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    },
    oauth: {
      domain: 'cfs-signin-uat.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://gatewayuat.cirencester-friendly.com/login',
      redirectSignOut: 'https://gatewayuat.cirencester-friendly.com/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        // sys
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal/',

        // UAT
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal//',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/Quote/SecureApply',

        // PP
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        
        // quotesIN2
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',

        // SSG-IN2
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        // IPL 1501/5
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_AdviserPortal/security/logon',
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_CustomerPortal/security/logon',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/Apply/',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/SecureApply',
      ],
      // Groups for federated users.
      federatedGroups: [
        "eu-west-2_87ztWeh5V_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'https://cesbuat.cirencester-friendly.co.uk/api'
    },
    ssgAdviserItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1500_copSSG_AdviserPortal"
      },
      {
        title: "SSG iPipeline 1530",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1530_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal"
      },
    ],
    ssgMemberItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tst01-web-a.tcp.local/tst_env_1500_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal"
      },
    ],
    dataItems: [],
  },
  // INT #######################################################################
  int: {
    featureFlags: {
      showFirmRegistration: true,
      showConfigOverrides: true,
      disableSelfSignup: true,
      profiles: true,
      scheduleEnvironment: true,
      cats: false,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomouat.cirencester-friendly.co.uk',
      siteId: 2
    },
    links: {
      firmRegistration: 'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      //loginUserType: '/login',
      loginUserType: '/login',
      menuHome: 'https://staging.cirencester-friendly.com',
      menuAboutUs: 'https://staging.cirencester-friendly.com/about-us/',
      governance: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/',
      accounts: 'https://staging.cirencester-friendly.com/documents/annual-reports-and-accounts/latest/',
      legal: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/legal/',
      cookies: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://staging.cirencester-friendly.com/documents/Privacy_Notice.pdf',
      accessibility: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://staging.cirencester-friendly.com/adviser/',
      menuMember: 'https://staging.cirencester-friendly.com/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
      
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_TVWlVxlcw",
      APP_CLIENT_ID: "5ab943m20ev9amvog6mku3ha7v",
      allowDelete: true,
      allowAdminDelete: true,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    },
    oauth: {
      domain: 'cfs-signin-int.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://gatewayint.cirencester-friendly.com/login',
      redirectSignOut: 'https://gatewayint.cirencester-friendly.com/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        // sys
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal/',

        // UAT
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal//',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/Quote/SecureApply',

        // PP
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        
        // quotesIN2
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',

        // SSG-IN2
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        // IPL 1501/5
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_AdviserPortal/security/logon',
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_CustomerPortal/security/logon',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/Apply/',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/SecureApply',
      ],
      // Groups for federated users.
      federatedGroups: [
        "eu-west-2_TVWlVxlcw_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'https://integralint.cirencester-friendly.co.uk/api'
    },
    ssgAdviserItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1500_copSSG_AdviserPortal"
      },
      {
        title: "SSG iPipeline 1530",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1530_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal"
      },
    ],
    ssgMemberItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tst01-web-a.tcp.local/tst_env_1500_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal"
      },
    ],
    dataItems: [],
  },
  // IN2 #######################################################################
  in2: {
    featureFlags: {
      showFirmRegistration: false,
      showConfigOverrides: true,
      disableSelfSignup: false,
      profiles: true,
      scheduleEnvironment: true,
      cats: false,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomouat.cirencester-friendly.co.uk',
      siteId: 2
    },
    links: {
      firmRegistration: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      //loginUserType: '/login',
      loginUserType: '/login',
      menuHome: 'https://staging.cirencester-friendly.com',
      menuAboutUs: 'https://staging.cirencester-friendly.com/about-us/',
      governance: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/',
      accounts: 'https://staging.cirencester-friendly.com/documents/annual-reports-and-accounts/latest/',
      legal: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/legal/',
      cookies: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://staging.cirencester-friendly.com/documents/Privacy_Notice.pdf',
      accessibility: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://staging.cirencester-friendly.com/adviser/',
      menuMember: 'https://staging.cirencester-friendly.com/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
      
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_VlFHzSsHF",
      APP_CLIENT_ID: "3t5ifjeunapejl4eogo3c51u39",
      allowDelete: true,
      allowAdminDelete: true,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    },
    oauth: {
      domain: 'cfs-signin-in2.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://gatewayin2.cirencester-friendly.com/login',
      redirectSignOut: 'https://gatewayin2.cirencester-friendly.com/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        // sys
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal',

        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal/',
        'https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal/',

        // UAT
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal//',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal//',

        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-uat-web.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal/Quote/SecureApply',

        // PP
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        
        // quotesIN2
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',

        'https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',

        // SSG-IN2
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal/',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal/',

        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal/Quote/SecureApply',
        'https://ssg-in2-web.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal/Quote/SecureApply',

        // IPL 1501/5
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_AdviserPortal/security/logon',
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_CustomerPortal/security/logon',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/Apply/',
        'https://origotesting.tcplifesystems.com/tst_env_1505_copSSG_AdviserPortal/Quote/SecureApply',
      ],
      // Groups for federated users.
      federatedGroups: [
        "eu-west-2_VlFHzSsHF_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'https://integralin2.cirencester-friendly.co.uk/api'
    },
    ssgAdviserItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1500_copSSG_AdviserPortal"
      },
      {
        title: "SSG iPipeline 1530",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1530_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_AdviserPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_AdviserPortal"
      },
    ],
    ssgMemberItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tst01-web-a.tcp.local/tst_env_1500_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 01",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 02",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 03",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 04",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 11",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG UAT 12",
        link: "https://ssg-uat-web-ext.cirencester-friendly.co.uk/uat_env_12_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 01",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 02",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 03",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 04",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG SYS 11",
        link: "https://cfs-aws-srv-003.cirencester-friendly.co.uk/sys_env_11_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 01",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_01_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 02",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_02_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 03",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_03_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 04",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_04_copSSG_CustomerPortal"
      },
      {
        title: "SSG IN2 11",
        link: "https://quotesin2.cirencester-friendly.co.uk/in2_env_11_copSSG_CustomerPortal"
      },
    ],
    dataItems: [],
  },
  // PP #######################################################################
  preprod: {
    featureFlags: {
      showFirmRegistration: false,
      showConfigOverrides: true,
      disableSelfSignup: true,
      profiles: true,
      scheduleEnvironment: true,
      cats: false,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomopp.cirencester-friendly.co.uk',
      siteId: 2
    },
    links: {
      firmRegistration: 'https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://ssg-pp-web.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      loginUserType: '/login',
      menuHome: 'https://staging.cirencester-friendly.com',
      menuAboutUs: 'https://staging.cirencester-friendly.com/about-us/',
      governance: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/',
      accounts: 'https://staging.cirencester-friendly.com/documents/annual-reports-and-accounts/latest/',
      legal: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/legal/',
      cookies: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://staging.cirencester-friendly.com/documents/Privacy_Notice.pdf',
      accessibility: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://staging.cirencester-friendly.com/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://staging.cirencester-friendly.com/adviser/',
      menuMember: 'https://staging.cirencester-friendly.com/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_n9iUPOCAK",
      APP_CLIENT_ID: "3bdejo66br2ao84qvkb2rk9qf2",
      allowDelete: false,
      allowAdminDelete: false,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    },
    oauth: {
      domain: 'cfs-signin-pp.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://gatewaypp.cirencester-friendly.co.uk/login',
      redirectSignOut: 'https://gatewaypp.cirencester-friendly.co.uk/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        // PP
        'https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal',
        'https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/',
        'https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal',
        'https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal/',
        'https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        // IPL 1501/5
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_AdviserPortal/security/logon',
        'https://cfs-tst01-web-a.tcp.local/tst_env_1501_copSSG_CustomerPortal/security/logon',
        // DR
        'https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal',
        'https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/',
        'https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_CustomerPortal',
        'https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_CustomerPortal/',
        'https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/Quote/SecureApply',
      ],
      // Groups for federated users.
      federatedGroups: [
        "eu-west-2_n9iUPOCAK_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'https://integralpp.cirencester-friendly.co.uk/api'
    },
    ssgAdviserItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1500_copSSG_AdviserPortal"
      },
      {
        title: "SSG iPipeline 1530",
        link: "https://cfs-tsta1-ext.ssgdigital.co.uk/tst_env_1530_copSSG_AdviserPortal"
      },
      {
        title: "Adviser portal (ssg-pp-web-ext)",
        link: "https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal"
      },
      {
        title: "Adviser portal (portalpp)",
        link: "https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_AdviserPortal"
      },
      {
        title: "Adviser portal (DR)",
        link: "https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal"
      },
    ],
    ssgMemberItems: [
      {
        title: "SSG iPipeline 1500",
        link: "https://cfs-tst01-web-a.tcp.local/tst_env_1500_copSSG_CustomerPortal"
      },
      {
        title: "Member portal (ssg-pp-web-ext)",
        link: "https://ssg-pp-web-ext.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal"
      },
      {
        title: "Member portal (portalpp)",
        link: "https://portalpp.cirencester-friendly.co.uk/pp_env_01_copSSG_CustomerPortal"
      },
      {
        title: "Member portal (portalpp)",
        link: "https://CFS-AWS-SRV-059.cirencester-friendly.co.uk/prd_env_01_copSSG_CustomerPortal"
      },
    ],
    dataItems: [
      {
        title: "PP Data Pipeline",
        link: "https://dagsterpp.cirencester-friendly.co.uk/runs",
      },
    ],
  },
  // PROD #######################################################################
  production: {
    featureFlags: {
      showFirmRegistration: false,
      showConfigOverrides: false,
      disableSelfSignup: true,
      profiles: true,
      scheduleEnvironment: false,
      cats: false,
      submitClaim: true,
    },
    analytics: {
      url: 'https://matomo.cirencester-friendly.co.uk',
      siteId: 1
    },
    links: {
      firmRegistration: 'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/Register',
      editAccountAdviser: 'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/MyAccount/MyAccount?ActivityName=ADP_MyAccount',
      editAccountMember: '',
      // Page that allows user to select their type before logging in.
      loginUserType: 'https://cirencester-friendly.co.uk/login/',
      menuHome: 'https://cirencester-friendly.co.uk',
      menuAboutUs: 'https://cirencester-friendly.co.uk/about-us/',
      governance: 'https://cirencester-friendly.co.uk/about-us/corporate-governance/',
      accounts: 'https://cirencester-friendly.co.uk/documents/annual-reports-and-accounts/latest/',
      legal: 'https://cirencester-friendly.co.uk/about-us/corporate-governance/legal/',
      cookies: 'https://cirencester-friendly.co.uk/about-us/corporate-governance/documents/cookie-notice',
      privacy: 'https://cirencester-friendly.co.uk/documents/Privacy_Notice.pdf',
      accessibility: 'https://cirencester-friendly.co.uk/about-us/corporate-governance/documents/accessibility',
      complaints: 'https://cirencester-friendly.co.uk/about-us/corporate-governance/documents/complaints-procedure',
      slavery: 'https://cirencester-friendly.co.uk/about-us/corporate-governance/documents/modern-slavery-statement/',
      menuAdviser: 'https://cirencester-friendly.co.uk/adviser/',
      menuMember: 'https://cirencester-friendly.co.uk/member/',
      // Others
      instagram: 'https://www.instagram.com/ciren_friendly/',
      facebook: 'https://www.facebook.com/CirencesterFriendly/',
      twitter: 'https://twitter.com/Ciren_friendly/',
    },
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_8xS7TBjVK",
      APP_CLIENT_ID: "6gd8hl5cl0jv1bgi8vrjomvc5s",
      allowDelete: false,
      allowAdminDelete: false,
      allowRegister: true,
    },
    federatedFirms: [
      {
        regex: "^.+@cfsdelta\\.onmicrosoft\\.com$",
        name: "CFS Delta",
        provider: "Cirencester-Friendly-Delta",
      }
    ],
    captcha: {
      enabled: true,
      siteKey: "6LdkEDsdAAAAANNKBcPSPoRCFouIyOY6ZrqN-ajl"
    },
    oauth: {
      domain: 'cfs-signin.auth.eu-west-2.amazoncognito.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: 'https://gateway.cirencester-friendly.co.uk/login',
      redirectSignOut: 'https://gateway.cirencester-friendly.co.uk/login',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      redirect_whitelist: [
        'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal',
        'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/',
        'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/Quote/SecureApply',
        'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal/Quote/SecureApply/',
        'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_CustomerPortal',
        'https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_CustomerPortal/',
      ],// Groups for federated users.
      federatedGroups: [
        "eu-west-2_8xS7TBjVK_Cirencester-Friendly"
      ]
    },
    api: {
      address: 'https://integral.cirencester-friendly.co.uk/api',
    },
    ssgMemberItems: [
      {
        title: "Member portal",
        link: "https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_CustomerPortal"
      },
    ],
    ssgAdviserItems: [
      {
        title: "Adviser portal",
        link: "https://portal.cirencester-friendly.co.uk/prd_env_01_copSSG_AdviserPortal"
      },
    ],
    dataItems: [
      {
        title: "Data Pipeline",
        link: "https://dagster.cirencester-friendly.co.uk/runs",
      },
    ],
  }
}

const config = {
  // Common settings here.
  // Default to local for tests etc.
  ...settings[
    (
      process.env.REACT_APP_STAGE === 'dev' ||
      process.env.REACT_APP_STAGE === 'int' ||
      process.env.REACT_APP_STAGE === 'in2' ||
      process.env.REACT_APP_STAGE === 'uat' ||
      process.env.REACT_APP_STAGE === 'preprod' ||
      process.env.REACT_APP_STAGE === 'production'
    )
    ?
    process.env.REACT_APP_STAGE :
    'local'
  ]
  //process.env.STORYBOOK ? 'local' : process.env.REACT_APP_STAGE]
}

export default config;
